import { defaultTo } from '../utils/bits'
import { signUserFunction } from './gallery-properties.flow'

export default signUserFunction(calcShowVoteCount)

function calcShowVoteCount(rawVal, calcProp) {
  const show_vote_count = defaultTo(rawVal, true)
  const allow_voting = calcProp('allow_voting')
  const has_votes = calcProp('has_votes')
  return show_vote_count && (allow_voting || has_votes)
}
